'use client';

import { FilterButtonGroup } from '@/components/filter-button-group';
import { useUser } from '@/components/providers/user-provider';
import { TabNavigation } from '@/components/tab-navigation';
import { useIsMobile } from '@/hooks/use-mobile';
import * as React from 'react';
import { profileTabs } from '../utils/constants';
import PaymentDetails from './payment-details';
import ProfileCard from './profile-card';
export function BasicDetails() {
  const [activeFilter, setActiveFilter] = React.useState('Personal');
  const {
    user
  } = useUser();
  const isMobile = useIsMobile();
  return <div className="relative flex size-full flex-col" data-sentry-component="BasicDetails" data-sentry-source-file="basic-details.tsx">
      {isMobile && <TabNavigation tabs={profileTabs} activeTab="Basic details" className="sticky top-20 z-10 " />}
      <div className="flex w-full justify-start">
        <FilterButtonGroup filters={['Personal', 'Bank & UPI']} activeFilter={activeFilter} onFilterChange={setActiveFilter} data-sentry-element="FilterButtonGroup" data-sentry-source-file="basic-details.tsx" />
      </div>
      <div className=" mb-28 flex w-full flex-col items-center gap-2  px-5 md:mb-20">
        {activeFilter === 'Personal' && <ProfileCard name={user?.name as string} phone={user?.phone as string} email="john.doe@example.com" aadhaarNumber="527790592780" address="1234 Main St, Anytown, USA" dateOfBirth="1990-01-01"
      // profileImage="/default-user.png"
      />}
        {activeFilter === 'Bank & UPI' && <PaymentDetails />}
      </div>
    </div>;
}